<ion-grid class="ion-no-padding">
  <ion-row>
    <ion-col [size]="iconColumns"><ng-content select=".app-launcher-icons"></ng-content></ion-col>
    <ion-col [size]="12 - iconColumns"><ng-content select=".app-launcher-body"></ng-content></ion-col>
  </ion-row>
</ion-grid>